export default "__VITE_ASSET__306e2a8a__"